import React from 'react';
import { connect } from 'react-redux';
import { bool, number, string } from 'prop-types';
import EmailLoginContainer from '../views/reactViews/EmailLoginContainer';
import { getRedirectUrl } from '../selectors/EmailLoginSelectors';
import BootstrapData from 'models/BootstrapData';
import { getAccessToken } from '../AuthToken';
import {
    eventGroupIdSelector,
    eventIdSelector,
    eventWelcomeMessagesSelector,
    getPublicWebsiteBaseUrlSelector,
    websiteTypeSelector,
    whitelabelPathSelector,
    whitelabelUrlSelector,
    whitelabelWidgetEnabledSelector,
    onlyEventDomainSelector
} from '../selectors/EventSelectors';
import {
    enableTicketIdLoginSelector,
} from '../selectors/LoginSelectors';

export const getIsAuthenticated = (state) => !!getAccessToken();

const isWidget = BootstrapData('bootstrap-data-isWidgetObject').isWidget;

const loginGateway = (TargetComponent) => (props) =>
    props.isAuthenticated ? (
        <TargetComponent {...props} />
    ) : (
        <EmailLoginContainer {...props} isWidget={isWidget} />
    );
loginGateway.propTypes = {
    isAuthenticated: bool,
    eventId: number,
    eventGroupId: number,
    enableTicketIdLogin: bool,
    redirectUrl: string,
};

const withEmailLogin = (TargetComponent) =>
    connect((state) => ({
        isAuthenticated: getIsAuthenticated(state),
        eventId: eventIdSelector(state),
        eventGroupId: eventGroupIdSelector(state),
        enableTicketIdLogin: enableTicketIdLoginSelector(state),
        publicWebsiteBaseUrl: getPublicWebsiteBaseUrlSelector(state),
        redirectUrl: getRedirectUrl(),
        welcomeMessage: eventWelcomeMessagesSelector(state),
        websiteType: websiteTypeSelector(state),
        whitelabelPath: whitelabelPathSelector(state),
        whitelabelUrl: whitelabelUrlSelector(state),
        whitelabelWidgetEnabled: whitelabelWidgetEnabledSelector(state),
        onlyEventDomainSelector: onlyEventDomainSelector(state)
    }))(loginGateway(TargetComponent));



export default withEmailLogin;
